/** Sentinel stored as `partnerId` when the transactions filter is not scoped to one partner. */
export const ALL_PARTNERS_ID = '__all__';

/** True when the filter is the all-partners choice rather than one partner's id. */
export function isAllPartners(partnerId: string): boolean {
  return partnerId === ALL_PARTNERS_ID;
}
